<div class="legend-bar">
    @for (element of legendElements(); track element.color) {
        <div [style.background-color]="element.color" class="legend-value">
            {{ element.display }}
        </div>
    }
</div>

<div class="legend-info">
    @if (allowOverrideToggle()) {
        <fa-icon
            class="clickable"
            [icon]="renderOverrideStyle() ? 'eye' : 'eye-slash'"
            (click)="toggleShowOverrides()"
            [matTooltip]="!renderOverrideStyle() ? 'Show Overrides' : 'Hide Overrides'"
            matTooltipPosition="above"
            matTooltipShowDelay="250">
        </fa-icon>
    }
    <div class="legend-item">
        <span #overrideHash class="outage-bg"></span>
        <span #overrideText class="override-text">Active Overrides</span>
    </div>

    <ng-content />
</div>
